import { AxiosError } from 'axios';
import { handleError } from '../../../../ui/err/handleError';
import { AxiosCommonError } from '../../../../../shared/types';
import { queries } from '../../../../../shared/queries';
import { useQuery } from '@tanstack/react-query';
import type { IProdoqCompanyIdParams } from '../../../../../shared/apis/prodoq/types';

export default function useGetProdoqRoles(params: IProdoqCompanyIdParams) {
  return useQuery({
    ...queries.prodoq.roles(params),
    enabled: !!params.companyId,
    select: (data) => data.data,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
